// Agregar y quitar un uniforme DENTRO del editor del plan.
//
// Antes esto vivia en una pantalla aparte ("Prendas por plan") que escribia directo
// en la base. Se retiro: armar un plan es un solo trabajo, y partirlo en dos
// pantallas obligaba a acordarse de ir a las dos. Ademas el efecto en el dinero solo
// se veia despues; aqui el marcador "Cuadra ✓" del editor lo muestra en el acto.
//
// Trabaja sobre el ESTADO LOCAL del editor: quien persiste es el guardado del plan
// (reconcilePlanItems + reconcileParcialidades). Por eso es puro y se prueba solo.

// El uniforme SIEMPRE lleva su propia parcialidad. La otra forma ("repartido en las
// mensualidades") se retiro: disolvia el costo en el total y dejaba a la prenda sin
// cargo propio, asi que no habia manera de fecharla, enlazarla al pedido ni saber si
// se pago. Con parcialidad propia el plan ademas sigue cuadrado solo.
//
// Nace SIN fecha a proposito: la fecha de pago la pone el PEDIDO, porque un pedido no
// es de todos -- el que entra en octubre no puede traer un vencimiento de julio.
// Ademas trae puesta su regla de entrega: "se entrega cuando pague ESTA prenda"
// (regla 'concepto'). Es la unica respuesta que no hay que preguntar -- la prenda ya
// tiene su propio cobro, asi que su pago ES la condicion. Preguntar "¿hasta que pago?"
// abria la puerta a atarla a una mensualidad que no tiene nada que ver, y peor: como
// el umbral de esa regla es ACUMULADO, elegir mal exigia casi el plan entero.
//
// Se puede cambiar despues en el paso Entregables, para el club que si quiera atarla
// a una mensualidad.
export const agregarUniformeAlPlan = (
  { conceptos = [], parcialidades = [], entregables = [] } = {},
  prenda = {},
) => {
  if (!prenda?.concepto_id) return { conceptos, parcialidades, entregables }
  if (conceptos.some((c) => c.concepto_id === prenda.concepto_id)) return { conceptos, parcialidades, entregables }

  const monto = Number(prenda.precio || 0)
  const yaTieneEntregable = entregables.some((e) => e.concepto_id === prenda.concepto_id)

  return {
    conceptos: [...conceptos, { concepto_id: prenda.concepto_id, monto }],
    parcialidades: [...parcialidades, {
      orden: parcialidades.length + 1,
      nombre: prenda.nombre || 'Uniforme',
      monto,
      fecha_limite: null,
      concepto_id: prenda.concepto_id,
    }],
    entregables: yaTieneEntregable ? entregables : [...entregables, {
      nombre: prenda.nombre || 'Uniforme',
      concepto_id: prenda.concepto_id,
      regla_tipo: 'concepto',
      hasta_orden: null,
    }],
  }
}

// Quitar el uniforme se lleva SU parcialidad y SU entregable. Si no, el calendario
// seguiria cobrando un jersey que el plan ya no incluye, y quedaria una regla de
// entrega sobre algo que no se entrega.
export const quitarUniformeDelPlan = (
  { conceptos = [], parcialidades = [], entregables = [] } = {},
  conceptoId,
) => ({
  conceptos: conceptos.filter((c) => c.concepto_id !== conceptoId),
  parcialidades: parcialidades.filter((p) => p.concepto_id !== conceptoId),
  entregables: entregables.filter((e) => e.concepto_id !== conceptoId),
})
